import { AnimatePresence, motion } from "framer-motion";
import { FC, useEffect, useState } from "react";

import { SheetClose } from "~/components/ui/sheet";
import useAuthRoute from "~/hook/useAuthRoute";
import { useFontStyle } from "~/hook/useFontStyle";
import { getSession } from "~/lib/helperFuncation/sessionStorageService";
import { listItemVariants, touchVariants } from "~/lib/motion-obj";
import { cn } from "~/lib/utils";
import { BLUR_HASH, FALLBACK_IMAGE_ALT_TEXT, FALLBACK_IMAGE_URL, SELECTED_ITEM } from "~/utils/constant";
import { wantsMobile } from "~/utils/helper-funcations";
import ImageWithSkeleton from "../ImageWithSkeleton";
import { PropsType } from "./type";

const ListView: FC<PropsType> = ({ data, category_name, shape, isImagePreloaded }) => {
  const [selectedList, setSelectedList] = useState<number | null>(Number(getSession(SELECTED_ITEM)) || null);
  // const { LocalizedLink } = useLocale();
  const { handleNavigate } = useAuthRoute();
  const { medium, regular } = useFontStyle();

  useEffect(() => {
    sessionStorage.setItem(SELECTED_ITEM, JSON.stringify(selectedList));
  }, [selectedList]);

  return (
    <div className="flex flex-col px-5  mb-5">
      {category_name && (
        <div className={cn("-px-2 my-2")}>
          <h2 className={cn("icon_category_type", medium)}>{category_name}</h2>
        </div>
      )}
      <AnimatePresence>
        <div>
          {data.map((item, index) => {
            const isVisible = wantsMobile(item.show_menu);
            return (
              isVisible && (
                <div
                  key={item.id}
                  onClick={() => handleNavigate(item.navigate_to)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      handleNavigate(item.navigate_to);
                    }
                  }}
                >
                  {/* <SheetClose
                    className={cn(
                      "w-full flex items-center gap-x-2 pt-0.5 pb-1.5 border-b border-b-textHeadingColor",
                      selectedList === item.id && "border-l-4 border-l-darkOrangeColor bg-secondaryColor",
                    )}
                  >
                    <motion.div onClick={() => setSelectedList(item.id)} variants={touchVariants} initial="initial" whileTap="tap">
                      <motion.div
                        className="flex gap-x-2 items-center"
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                        variants={listItemVariants}
                        transition={{
                          duration: 0.3,
                          delay: index * 0.1,
                        }}
                      >
                        <div className="overflow-hidden flex justify-start items-center icon-menu-image-parent">
                          <ImageWithSkeleton
                            url={{
                              small: typeof item.img === "string" ? item.img : item.img?.s?.url || FALLBACK_IMAGE_URL,
                              medium: typeof item.img === "string" ? item.img : item.img?.m?.url || FALLBACK_IMAGE_URL,
                              large: typeof item.img === "string" ? item.img : item.img?.l?.url || FALLBACK_IMAGE_URL,
                              hd: typeof item.img === "string" ? item.img : item.img?.hd?.url || FALLBACK_IMAGE_URL,
                              original: typeof item.img === "string" ? item.img : item.img?.og?.url || FALLBACK_IMAGE_URL,
                            }}
                            alt={item.name ?? "Icon"}
                            blur_hash={item.img?.bh || BLUR_HASH}
                            className={cn("icon-menu-image object-cover")}
                            loadImageLazy={false}
                            isPreloaded={isImagePreloaded?.(typeof item.img === "string" ? item.img : item.img?.s?.url || "") || false}
                            useSkeletonLoader={true}
                          />
                        </div>
                        <p
                          className={cn(
                            "icon_category_name font-semibold !text-start capitalize !p-0",
                            regular,
                            selectedList === item.id ? "text-jetBlack" : "",
                          )}
                        >
                          {item.name}
                        </p>
                      </motion.div>
                    </motion.div>
                  </SheetClose> */}

                  <SheetClose
                    className={cn(
                      "w-full flex  gap-x-3 py-2 border-b border-b-textHeadingColor/30",
                      selectedList === item.id && "border-l-4 border-l-darkOrangeColor bg-secondaryColor",
                    )}
                  >
                    <motion.div onClick={() => setSelectedList(item.id)} variants={touchVariants} initial="initial" whileTap="tap" className="w-full">
                      <motion.div
                        className="flex gap-x-3 w-full items-center justify-center" // ✅ items-center here is key
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                        variants={listItemVariants}
                        transition={{ duration: 0.3, delay: index * 0.1 }}
                      >
                        <div className="flex-shrink-0 overflow-hidden rounded-md flex items-center justify-center">
                          <ImageWithSkeleton
                            url={{
                              small: typeof item.img === "string" ? item.img : item.img?.s?.url || FALLBACK_IMAGE_URL,
                              medium: typeof item.img === "string" ? item.img : item.img?.m?.url || FALLBACK_IMAGE_URL,
                              large: typeof item.img === "string" ? item.img : item.img?.l?.url || FALLBACK_IMAGE_URL,
                              hd: typeof item.img === "string" ? item.img : item.img?.hd?.url || FALLBACK_IMAGE_URL,
                              original: typeof item.img === "string" ? item.img : item.img?.og?.url || FALLBACK_IMAGE_URL,
                            }}
                            alt={item.name ?? FALLBACK_IMAGE_ALT_TEXT}
                            blur_hash={item.img?.bh || BLUR_HASH}
                            className={cn("object-cover max-w-[65px] max-h-[65px]")}
                            loadImageLazy={false}
                            isPreloaded={isImagePreloaded?.(typeof item.img === "string" ? item.img : item.img?.s?.url || "") || false}
                            useSkeletonLoader={true}
                          />
                        </div>

                        <p className={cn("icon_category_name !text-start !p-0", regular, selectedList === item.id ? "text-jetBlack" : "")}>
                          {item.name}
                        </p>
                      </motion.div>
                    </motion.div>
                  </SheetClose>
                </div>
              )
            );
          })}
        </div>
      </AnimatePresence>
    </div>
  );
};

export default ListView;
